export default "__VITE_ASSET__DeKKn2cR__"